<template>
  <div class="yuanhui-admin-login">
    <!-- 背景装饰 -->
    <div class="background-decoration">
      <div class="particle particle-1"></div>
      <div class="particle particle-2"></div>
      <div class="particle particle-3"></div>
      <div class="particle particle-4"></div>
      <div class="particle particle-5"></div>
      <div class="particle particle-6"></div>
      <div class="light-effect"></div>
    </div>
    
    <div class="login-container">
      <div class="login-header">
        <div class="logo-section">
          <img src="@/assets/logo.png" alt="元回科技" class="company-logo">
          <h1>元回科技管理后台</h1>
        </div>
        <p>AI助力美好未来</p>
      </div>
      
      <div class="login-form">
        <div class="input-group">
          <div class="input-wrapper">
            <div class="input-icon">
              <i class="fas fa-user"></i>
            </div>
            <input 
              type="text" 
              v-model="username" 
              placeholder="请输入用户名"
              class="login-input"
              @keyup.enter="handleLogin"
            >
          </div>
        </div>
        
        <div class="input-group">
          <div class="input-wrapper">
            <div class="input-icon">
              <i class="fas fa-lock"></i>
            </div>
            <input 
              type="password" 
              v-model="password" 
              placeholder="请输入密码"
              class="login-input"
              @keyup.enter="handleLogin"
            >
          </div>
        </div>
        
        <button 
          class="login-btn" 
          @click="handleLogin"
          :disabled="isLoading"
        >
          <div class="btn-content">
            <i v-if="!isLoading" class="fas fa-arrow-right"></i>
            <div v-if="isLoading" class="loading-spinner"></div>
            <span>{{ isLoading ? '登录中...' : '登录系统' }}</span>
          </div>
        </button>
      </div>
      
                   <div class="login-footer">
        <p>© 2025 元回科技 版权所有</p>
      </div>
     </div>
     
           <!-- 自定义提示框 -->
      <div v-if="showAlert" class="alert-overlay" @click="closeAlert">
        <div class="alert-modal" @click.stop>
          <div class="alert-icon">
            <i :class="getAlertIcon()"></i>
          </div>
          <div class="alert-content">
            <h3>{{ getAlertTitle() }}</h3>
            <p>{{ alertMessage }}</p>
          </div>
          <div class="alert-actions">
            <button class="alert-btn" @click="closeAlert">确定</button>
          </div>
        </div>
      </div>
   </div>
 </template>

<script>
import request from '@/utils/request';

export default {
  name: 'AdminLogin',
  data() {
    return {
      username: '',
      password: '',
      isLoading: false,
      showAlert: false,
      alertMessage: ''
    }
  },
  methods: {
    async handleLogin() {
      if (!this.username || !this.password) {
        this.showCustomAlert('请输入用户名和密码');
        return;
      }
      
      this.isLoading = true;
      
      try {
        const response = await request.post('/api/admin/login', {
          username: this.username,
          password: this.password
        });
        
        const data = response.data;
        
        if (data.success) {
          // 保存登录状态
          localStorage.setItem('adminToken', data.token);
          localStorage.setItem('adminUser', JSON.stringify(data.user));
          
          // 跳转到管理后台
          this.$router.push('/adminyuanhui66');
        } else {
          this.showCustomAlert(data.message || '登录失败');
        }
      } catch (error) {
        this.showCustomAlert('登录失败，请重试');
      } finally {
        this.isLoading = false;
      }
    },
    
    showCustomAlert(message) {
      this.alertMessage = message;
      this.showAlert = true;
    },
    
    closeAlert() {
      this.showAlert = false;
    },
    
    getAlertIcon() {
      return 'fas fa-info-circle';
    },
    
    getAlertTitle() {
      return '提示';
    }
  }
}
</script>

<style scoped>
.yuanhui-admin-login {
  min-height: 100vh;
  background: linear-gradient(135deg, #001529 0%, #003366 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  position: relative;
  overflow: hidden;
}

/* 背景装饰 */
.background-decoration {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

.light-effect {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(0,102,255,0.05) 0%, rgba(0,0,0,0) 70%);
  animation: pulse 15s ease-in-out infinite;
}

.particle {
  position: absolute;
  border-radius: 50%;
  background: rgba(0, 153, 255, 0.1);
  box-shadow: 0 0 10px rgba(0, 153, 255, 0.3);
  animation: float 10s ease-in-out infinite;
}

.particle-1 {
  width: 100px;
  height: 100px;
  top: 15%;
  left: 10%;
  animation-delay: 0s;
}

.particle-2 {
  width: 150px;
  height: 150px;
  top: 60%;
  right: 15%;
  animation-delay: 2s;
}

.particle-3 {
  width: 80px;
  height: 80px;
  bottom: 20%;
  left: 20%;
  animation-delay: 4s;
}

.particle-4 {
  width: 120px;
  height: 120px;
  top: 10%;
  right: 30%;
  animation-delay: 1s;
}

.particle-5 {
  width: 60px;
  height: 60px;
  bottom: 10%;
  right: 10%;
  animation-delay: 3s;
}

.particle-6 {
  width: 90px;
  height: 90px;
  top: 40%;
  left: 5%;
  animation-delay: 5s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
    opacity: 0.3;
  }
  50% {
    transform: translateY(-30px) rotate(180deg);
    opacity: 0.5;
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.2;
    transform: scale(1);
  }
  50% {
    opacity: 0.4;
    transform: scale(1.1);
  }
}

.login-container {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  padding: 50px 40px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  width: 100%;
  max-width: 420px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
  z-index: 1;
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.logo-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
}

.company-logo {
  width: 100px;
  height: auto;
  margin-bottom: 10px;
}

.login-header h1 {
  color: #003366;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  background: linear-gradient(135deg, #003366, #0066cc);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.login-header p {
  color: #0066cc;
  font-size: 16px;
  margin: 5px 0 0;
  font-weight: 500;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.input-group {
  position: relative;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 16px;
  color: #0066cc;
  font-size: 18px;
  z-index: 2;
}

.login-input {
  width: 100%;
  padding: 16px 16px 16px 50px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 16px;
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.login-input:focus {
  outline: none;
  border-color: #0066cc;
  box-shadow: 0 0 0 4px rgba(0, 102, 204, 0.1);
  background: white;
}

.login-input::placeholder {
  color: #adb5bd;
}

.login-btn {
  background: linear-gradient(135deg, #003366, #0066cc);
  color: white;
  border: none;
  padding: 16px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 8px;
}

.login-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 102, 204, 0.4);
  background: linear-gradient(135deg, #004080, #0077cc);
}

.login-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.btn-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.login-footer {
  text-align: center;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e9ecef;
}

.login-footer p {
  color: #003366;
  font-size: 14px;
  margin: 0;
  font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .login-container {
    padding: 40px 30px;
    margin: 20px;
  }
  
  .logo-icon {
    width: 60px;
    height: 60px;
    font-size: 24px;
  }
  
  .login-header h1 {
    font-size: 24px;
  }
  
     .login-input {
     padding: 14px 14px 14px 45px;
     font-size: 16px;
   }
 }

/* 自定义提示框样式 */
.alert-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  backdrop-filter: blur(8px);
}

.alert-modal {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  padding: 40px;
  max-width: 380px;
  width: 90%;
  text-align: center;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.2);
  animation: alertSlideIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes alertSlideIn {
  from {
    opacity: 0;
    transform: translateY(-30px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.alert-icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 28px;
  color: white;
  font-size: 32px;
  background: linear-gradient(135deg, #003366, #0066cc);
  box-shadow: 0 8px 25px rgba(0, 102, 204, 0.3);
}

.alert-content h3 {
  margin: 0 0 16px 0;
  color: #003366;
  font-size: 22px;
  font-weight: 600;
  background: linear-gradient(135deg, #003366, #0066cc);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.alert-content p {
  margin: 0 0 36px 0;
  color: #333333;
  font-size: 16px;
  line-height: 1.6;
  font-weight: 400;
}

.alert-actions {
  display: flex;
  justify-content: center;
}

.alert-btn {
  background: linear-gradient(135deg, #003366, #0066cc);
  color: white;
  border: none;
  padding: 14px 36px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 102, 204, 0.3);
}

.alert-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 102, 204, 0.4);
  background: linear-gradient(135deg, #004080, #0077cc);
}

.alert-btn:active {
  transform: translateY(0);
}
</style> 